/**
 * Annuity Association — horizontal color logo (PNG, served from /public).
 *
 * Source: AA brand library (Annuity Association_Logo_Horizontal_Color.jp2,
 * converted to PNG at 800×267, ~45KB compressed).
 *
 * Designed for light backgrounds. For a white-on-dark variant (e.g. emails,
 * dark-themed pages), use the stacked white SVG paths from prior versions of
 * this file.
 */

interface Props {
  className?: string;
  alt?: string;
}

export function Logo({ className, alt = 'Annuity Association' }: Props) {
  return (
    <img
      className={className}
      src="/logo-horizontal.png"
      alt={alt}
      width={800}
      height={267}
      decoding="async"
    />
  );
}
